export default __webpack_public_path__ + "static/media/pizza.91e3e462.png";